// import React from "react";
// import { Form } from "react-bootstrap";
// import "../App.css";

// export default function CustomInput({
//   label,
//   value,
//   onChange,
//   type = "text",
//   className = "",
//   ...rest
// }) {
//   return (
//     <div className={`custom-input-box ${className}`}>
//       {label && <Form.Label className="custom-input-label">{label}</Form.Label>}
//       <Form.Control
//         type={type}
//         value={value}
//         onChange={onChange}
//         className="custom-input"
//         {...rest}
//       />
//     </div>
//   );
// }


import React from "react";
import { Form } from "react-bootstrap";
import "../App.css";

export default function CustomInput({
  label,
  value,
  onChange,
  type = "text",
  className = "",
  labelClassName = "",
  wrapperClassName = "",
  ...rest
}) {
  return (
    <div className={`custom-input-box ${wrapperClassName}`}>
      {label && (
        <Form.Label className={`custom-input-label ${labelClassName}`}>
          {label}
        </Form.Label>
      )}
      <Form.Control
        type={type}
        value={value}
        onChange={onChange}
        className={`custom-input ${className}`}
        {...rest}
      />
    </div>
  );
}